import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  BondRequestStatePipe,
  BondSubTypePipe,
  BondTypePipe,
  BrokerDistributionTypePipe,
  ContactTypePipe,
  CouponTypePipe,
  CustomDateByUtcPipe,
  CustomDateTimeByUtcPipe,
  CustomUserDateTimePipe,
  EmptyGuidPipe,
  GlobalAlertTypePipe,
  IdentifierPipe,
  IdentifierQualPipe,
  IsfCustomStatePipe,
  JoinByPipe,
  LengthLimitPipe,
  LengthUnitPipe,
  PackageStatePipe,
  PackageTypePipe,
  PaymentRequestStatePipe,
  PaymentStateTranslatePipe,
  ProductCodePipe,
  QuoteStatePipe,
  ReferenceNumberLinkPipe,
  SafeDataPipe,
  WeightUnitPipe,
  YesNoPipe,
} from './pipes';

import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [
    PaymentStateTranslatePipe,
    CustomUserDateTimePipe,
    CustomDateByUtcPipe,
    IdentifierPipe,
    QuoteStatePipe,
    PackageTypePipe,
    PackageStatePipe,
    PaymentRequestStatePipe,
    ProductCodePipe,
    LengthUnitPipe,
    LengthLimitPipe,
    WeightUnitPipe,
    IdentifierQualPipe,
    BondRequestStatePipe,
    BondTypePipe,
    BondSubTypePipe,
    YesNoPipe,
    BrokerDistributionTypePipe,
    ContactTypePipe,
    CouponTypePipe,
    GlobalAlertTypePipe,
    IsfCustomStatePipe,
    ReferenceNumberLinkPipe,
    JoinByPipe,
    EmptyGuidPipe,
    CustomDateTimeByUtcPipe,
    SafeDataPipe,
  ],
  imports: [CommonModule, TranslateModule],
  exports: [
    PaymentStateTranslatePipe,
    CustomUserDateTimePipe,
    CustomDateByUtcPipe,
    IdentifierPipe,
    QuoteStatePipe,
    PackageTypePipe,
    PackageStatePipe,
    PaymentRequestStatePipe,
    ProductCodePipe,
    LengthUnitPipe,
    LengthLimitPipe,
    WeightUnitPipe,
    IdentifierQualPipe,
    BondRequestStatePipe,
    BondTypePipe,
    BondSubTypePipe,
    YesNoPipe,
    BrokerDistributionTypePipe,
    ContactTypePipe,
    CouponTypePipe,
    GlobalAlertTypePipe,
    IsfCustomStatePipe,
    ReferenceNumberLinkPipe,
    JoinByPipe,
    EmptyGuidPipe,
    CustomDateTimeByUtcPipe,
    SafeDataPipe,
  ],
})
export class PipesSharedModule {}
